import { apiProxyRequest } from "Api/apiProxyRequest";
import { fetchAllPages } from "Api/utils";

import type { BillingProfileDetailResponse } from "../types";

export const getUserBillingProfileDetailsRequest = (userId: string) => {
  return fetchAllPages(
    apiProxyRequest<BillingProfileDetailResponse>(
      `/users/${userId}/billing/profiles`
    )
  );
};
